<template>
    <transition :css="false" @enter="intro" @leave="outro" appear="">
        <section class="ChapterVideo">
            <video-modal
                v-if="visible"
                :artist-name="activeChapter.name"
                :artist-number="index"
                :hide-controls-time="2500"
                :poster="poster"
                :src="src"
                ref="videoModal"
            ></video-modal>
            <close-link @close="pauseVideo" :to="closeTo"></close-link>
        </section>
    </transition>
</template>

<script>
    import * as routes from '@/app/routes'
    import ChapterUtils from '@/app/mixins/ChapterUtils'
    import VideoModal from '@/app/components/VideoModal'
    import CloseLink from '@/app/components/CloseLink'

    export default {
        name: 'ChapterVideo',
        mixins: [
            ChapterUtils,
        ],
        components: {
            VideoModal,
            CloseLink,
        },
        data: () => ({
            visible: false,
        }),
        methods: {
            pauseVideo() {
                this.$refs.videoModal.videoPause();
            },
            intro(el, done) {
                TweenLite.fromTo(el, 2, {
                    alpha: 0,
                }, {
                    alpha: 1,
                    onComplete: () => {
                        this.visible = true;
                        done();
                    },
                })
            },
            outro(el, done) {
                TweenLite.to(el, 1, {
                    alpha: 0,
                    onComplete: () => {
                        this.visible = false;
                        done();
                    },
                    ease: Cubic.easeOut,
                })
            }
        },
        computed: {
            index() {
                const {activeChapterIndex} = this
                return activeChapterIndex + 1
            },
            poster() {
                const {chapterVideoCoverList, activeChapterIndex} = this
                return chapterVideoCoverList[activeChapterIndex]
            },
            src() {
                const {chapterVideoSrcList, activeChapterIndex} = this
                return chapterVideoSrcList[activeChapterIndex]
            },
            closeTo() {
                return {
                    name: routes.CHAPTER,
                }
            },
        },
    }
</script>

<style src="styles/views/ChapterVideo.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/views/ChapterVideo.vue